export const SEARCH_GODOWN = 'SEARCH_GODOWN'
export const STORE_GODOWN_RESULT = 'STORE_GODOWN_RESULT'
